import React from 'react';
import { Modal } from 'react-bootstrap';
import Chart from 'react-apexcharts';
import { FaTimes } from 'react-icons/fa';

/**
 * @file ExpandedChartModal.js
 * @description Modal for displaying an expanded version of a chart.
 */
const ExpandedChartModal = ({ show, title, options, series, type, onClose }) => {
    if (!show) return null;

    // Clone options to ensure they work in the modal and potentially adjust height/width or toolbar
    const expandedOptions = {
        ...options,
        chart: {
            ...options.chart,
            toolbar: { show: true },
            zoom: {
                enabled: !['treemap', 'pie', 'donut', 'radialBar'].includes(type),
                type: 'x',
                autoScaleYaxis: true
            },
            animations: { enabled: true },
            width: '100%'
        },
        title: {
            text: undefined, // Hide internal title if any, we use modal header
        }
    };

    return (
        <Modal show={show} onHide={onClose} size="xl" centered contentClassName="border-0 shadow-lg" dialogClassName="modal-90w">
            <div className="p-4 bg-white rounded-3">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fw-bold mb-0">{title}</h4>
                    <button className="btn btn-close" onClick={onClose}></button>
                </div>
                <div style={{ minHeight: '500px' }}>
                    <Chart
                        options={expandedOptions}
                        series={series}
                        type={type}
                        height={500}
                        width="100%"
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ExpandedChartModal;
